import React from 'react';
import { Link } from 'react-router-dom';
import { Signout } from '../actions'
import { connect } from 'react-redux'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

const signincomps = (props) => {
    return (
        <>
            <Link className=" nav-link item" to="/createproject">
                create
           <FontAwesomeIcon icon="plus-circle" style={{marginLeft:"5px"}}/>  
           </Link>
            <Link onClick={props.Signout} className="nav-link item" to="/login">
                Sign Out
            <FontAwesomeIcon icon="sign-out-alt" style={{marginLeft:"5px"}} /> 
            </Link>
            <div className="item av"><h4 className="avatar">{props.initials}</h4></div>
       </> 
    )
}
export default connect(null, {Signout})(signincomps)